interface Medias {
  mediaType: string | null;
  fullImage: string | null;
}

export function itemMedia(mediasArray: Medias[], mediaType: string): string[];
export function itemMedia(mediasArray: Medias[], mediaType: string[]): string[];

export function itemMedia(medias, mediaType) {
  if (typeof mediaType === 'string') {
    return medias.reduce((acc: string[], cur) => {
      if (cur.mediaType.toLowerCase().startsWith(mediaType)) {
        return [...acc, cur.fullImage];
      }

      return acc;
    }, []);
  }
  return medias.reduce((acc: string[], cur) => {
    if (
      !!mediaType.find(mediaTypeString =>
        cur.mediaType.toLowerCase().startsWith(mediaTypeString),
      )
    ) {
      return [...acc, cur.fullImage];
    }

    return acc;
  }, []);
}
